import { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { useAccount } from "wagmi";
import { Button } from "@/src/components";
import { ConnectButton } from "@/src/components/connectButton";
import { useBalances } from "@/src/hooks/useBalances";
import { useStake } from "@/src/hooks/useStake";
import { toast } from "react-hot-toast";
import { shortenAddress } from "@/src/lib/address";
import { LiquidityButton } from "@/src/views/home";
import { activeChain } from "@/src/configs/chainConfig";


export const Recharge = () => {
  const { chain } = useAccount();
  const {  onCharge, onChargeReborn } = useStake();
  const { address, isConnected } = useAccount();
  const { balance, stakeBalance, cnyxBalance, charged, unCharged, rewardPoints, chargeAmount, chargeReborn} = useBalances();
  const submitButtonRef = useRef(null);

  const [{ isStake, placeholder }, setOption] = useState({
    isStake: true,
    placeholder: "Amount of Canary Reborn NFTs",
  });
  const [{ isCorrectChain }, setState] = useState({
    isCorrectChain: true,
  });

  useEffect(() => {
    if (isConnected)
      setState({
        isCorrectChain: chain?.id === Number(activeChain.chainId),
      });
    
  }, [chain, isConnected]);

  const [{ stakeInput, unstakeInput, stakeInputReborn }, setInput] = useState({
    stakeInput: "",
    unstakeInput: "",
    stakeInputReborn:"",
  });
  {/*useEffect(() => {
    submitButtonRef.current &&
      (() => {
        submitButtonRef.current.disabled = true;

        if (isStake) {
          if (rewardPoints == 0 || stakeInput > parseFloat(unCharged).toFixed(0) || (parseInt(chargeAmount)*parseInt(stakeInput)) > rewardPoints ) {
            submitButtonRef.current.innerHTML = "insufficient balance";
            return;
          }
          if (stakeInput) {
            submitButtonRef.current.innerHTML = "Recharge";
            submitButtonRef.current.disabled = false;
            return;
          }
          submitButtonRef.current.innerHTML = "Enter quantity";

          return;
        }

        submitButtonRef.current.innerHTML = "Enter quantity";
          return;
      })();
  }, [isStake, stakeInput, unstakeInput, balance, stakeBalance, cnyxBalance, unCharged, charged, stakeInputReborn]);*/}

  const onInputChange = (event) => {
    const value = event.target.valueAsNumber;
    const _stakeInput = isStake ? value : stakeInput;
    setInput({
      stakeInput: _stakeInput,
      unstakeInput:_stakeInput,
    });
  };
  const onInputChangeReborn = (event) => {
    const value = event.target.valueAsNumber;
    const _stakeInput = isStake ? value : stakeInputReborn;
    setInput({
      stakeInputReborn: _stakeInput,
      unstakeInput:_stakeInput,
    });
  };

  const onMaxBalance = () => {
    var balance = 0;
    if(unCharged > 0 && chargeAmount > 0 && (parseInt(rewardPoints) >=(parseInt(unCharged)*parseInt(chargeAmount)))){
      balance = parseInt(unCharged);
    }
    if(unCharged > 0 && parseInt(rewardPoints) < (parseInt(unCharged)*parseInt(chargeAmount))){
      balance = Math.floor(parseInt(parseFloat((parseInt(rewardPoints)/parseInt(chargeAmount)))));
    }
    if (isStake)
      return setInput((prev) => ({
        ...prev,
        stakeInput: balance,
      }));
    setInput((prev) => ({
      ...prev,
      unstakeInput: balance,
    }));
  };

  const onMaxBalanceReborn = () => {
    var tmpBalance = 0;
    if(unCharged > 0 && chargeReborn > 0 && (parseInt(balance) >=(parseInt(unCharged)*parseInt(chargeReborn)))){
      tmpBalance = parseInt(unCharged);
    }
    if(unCharged > 0 && parseInt(balance) < (parseInt(unCharged)*parseInt(chargeReborn))){
      tmpBalance = Math.floor(parseInt(parseFloat((parseInt(balance)/parseInt(chargeReborn)))));
    }
    if (isStake)
      return setInput((prev) => ({
        ...prev,
        stakeInputReborn: tmpBalance,
      }));
    setInput((prev) => ({
      ...prev,
      unstakeInput: tmpBalance,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!isConnected) return;
    if (isStake)
      return toast.promise(onCharge(stakeInput), {
        loading: "Transaction is in progress",
        success: "Successfully charged Canary Reborn NFTs",
        error: (data) => data,
      });
  };

  const handleSubmitReborn = async (event) => {
    event.preventDefault();
    if (!isConnected) return;
    if (isStake)
      return toast.promise(onChargeReborn(stakeInputReborn), {
        loading: "Transaction is in progress",
        success: "Successfully charged Canary Reborn NFTs",
        error: (data) => data,
      });
  };


  return (
    <div className="md:border-2 border-foreground/10 max-w-xl mx-auto w-full rounded-md md:p-8" py-5>
      <div className= "py-2 flex justify-center">
       <h2 className="text-foreground text-2xl font-medium flex gap-2 py-1">
                 Canary Reborn NFT
      </h2>
      </div>
       <div className="flex justify-center">
       <img src={process.env.PUBLIC_URL + 'Reborn_NFT.png'} width="350" heigh="350" style={{ alignItems: 'center', alignSelf: 'center', justifyContent: 'center' }} />
       </div>
      <form onSubmit={handleSubmit}>
        <div className="mt-8 p-1 pr-0">
          <div className="flex w-full">
            <input
              value={stakeInput}
              max={parseFloat(unCharged).toFixed(0)}
              onChange={onInputChange}
              placeholder={placeholder}
              className="text-foreground font-medium w-[80%] rounded-md rounded-tr-none rounded-br-none border-[3px] border-primary/60 border-r-0 bg-background hover:border-primary outline-0 px-3"
              type="number"
              required
            />

            <span className="w-1/5">
              <Button
                type="button"
                onClick={onMaxBalance}
                className="rounded-tl-none rounded-bl-none"
              >
                max
              </Button>
            </span>
          </div>
        </div>
        <div className="flex justify-center py-1 text-foreground/50">
           <p><b>Rechargeable Canary Reborn NFTs:</b> {parseFloat(unCharged).toFixed(0)}</p>
        </div>
        <div className="flex justify-center py-1 text-foreground/50">
           {unCharged > 0 && <p><b>Harvest Points:</b> {parseFloat(rewardPoints).toFixed(2)}/{parseInt(stakeInput) * parseInt(chargeAmount)} ({chargeAmount} each)</p>}
        </div>
        

        <div className="mt-10">
        
          <Button type="submit" disabled={!isCorrectChain || unCharged==0 || unCharged < stakeInput || rewardPoints < Math.floor((parseInt(stakeInput)*parseInt(chargeAmount))) || stakeInput==0}>Recharge with harvest points</Button>
        
        </div>
      </form>
      <form onSubmit={handleSubmitReborn}>
        <div className="mt-8 p-1 pr-0">
          <div className="flex w-full">
            <input
              value={stakeInputReborn}
              max={parseFloat(unCharged).toFixed(0)}
              onChange={onInputChangeReborn}
              placeholder={placeholder}
              className="text-foreground font-medium w-[80%] rounded-md rounded-tr-none rounded-br-none border-[3px] border-primary/60 border-r-0 bg-background hover:border-primary outline-0 px-3"
              type="number"
              required
            />

            <span className="w-1/5">
              <Button
                type="button"
                onClick={onMaxBalanceReborn}
                className="rounded-tl-none rounded-bl-none"
              >
                max
              </Button>
            </span>
          </div>
        </div>
        <div className="flex justify-center py-1 text-foreground/50">
           <p><b>Rechargeable Canary Reborn NFTs:</b> {parseFloat(unCharged).toFixed(0)}</p>
        </div>
        <div className="flex justify-center py-1 text-foreground/50">
           {unCharged > 0 && <p><b>CRB:</b> {parseFloat(balance).toFixed(2)}/{parseInt(stakeInputReborn) * parseInt(chargeReborn)} ({chargeReborn} each)</p>}
        </div>
      

        <div className="mt-10 py-2">
        
          <Button type="submit" disabled={!isCorrectChain || unCharged==0 || unCharged < stakeInputReborn || balance < Math.floor((parseInt(stakeInputReborn)*parseInt(chargeReborn))) || stakeInputReborn==0}>Recharge with CRB</Button>
          
        </div>
      </form>
    </div>
  );
};
